import { theme } from '@notino/react-styleguide'
import styled, { css } from 'styled-components'
import { SALON_PAGE_MOBILE_BREAKPOINT } from '../../../../styles/constants'
import { NotinoBodyLarge, NotinoBodyMedium, NotinoLabelSmall400, NotinoTitleExtraLarge, NotinoTitleMedium, truncate } from '../../../../styles/helpers'

const ORDER_LAST_ITEM = 999

export const Container = styled.header`
	margin-bottom: 32px;
	margin-top: 24px;

	@media (min-width: ${SALON_PAGE_MOBILE_BREAKPOINT}) {
		margin-bottom: 40px;
		margin-top: 0;
	}
`

export const NameAndLogoContainer = styled.div`
	display: flex;
	gap: 8px;
	align-items: center;
`

export const LogoWrapper = styled.div`
	width: 40px;
	height: 40px;
`

export const Logo = styled.img`
	width: 100%;
	height: 100%;
	object-fit: contain;
`

export const Name = styled.h1`
	/* resetting global notino margin on heading */
	margin: 0;

	${NotinoTitleMedium};

	@media (min-width: ${SALON_PAGE_MOBILE_BREAKPOINT}) {
		${NotinoTitleExtraLarge};
	}
`

export const AdditionalInfoContainer = styled.div`
	${NotinoBodyMedium};
	display: flex;
	flex-direction: column;
	margin-top: 4px;
	gap: 4px;

	@media (min-width: ${SALON_PAGE_MOBILE_BREAKPOINT}) {
		${NotinoBodyLarge};
		flex-direction: row;
		align-items: flex-start;
		flex-wrap: wrap;
		align-items: center;
		margin-top: 16px;
		gap: 8px;
	}
`

const divider = css`
	@media (min-width: ${SALON_PAGE_MOBILE_BREAKPOINT}) {
		&:not(:last-child) {
			position: relative;
			margin-right: 12px;

			&::after {
				content: '';
				top: 50%;
				right: -10px;
				width: 4px;
				height: 4px;
				border-radius: 50%;
				background-color: ${theme.color.text.tertiary};
				transform: translate(50%, -50%);
				position: absolute;
			}
		}
	}
`

export const Address = styled.div`
	${NotinoBodyMedium};

	@media (min-width: ${SALON_PAGE_MOBILE_BREAKPOINT}) {
		${NotinoBodyLarge};
	}

	${divider};
`

export const ShowOnMapLink = styled.a`
	${NotinoBodyMedium};
	color: ${theme.color.text.tertiary};
	text-decoration: underline;
	padding-left: 8px;

	@media (min-width: ${SALON_PAGE_MOBILE_BREAKPOINT}) {
		${NotinoBodyLarge};
	}
`

export const RatingsContainer = styled.div`
	${divider};
	order: ${ORDER_LAST_ITEM};
	display: flex;
	align-items: center;
	gap: 4px;

	svg {
		display: block;
	}

	@media (min-width: ${SALON_PAGE_MOBILE_BREAKPOINT}) {
		order: unset;
	}
`

export const RatingsCount = styled.span`
	font-size: 1rem;
	line-height: 1.5rem;
	color: ${theme.color.text.tertiary};
`

export const AverageRatingValue = styled.span`
	font-size: 1rem;
	line-height: 1.5rem;
`

export const OpeningHours = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;

	svg {
		flex-shrink: 0;
	}

	${divider};
`

export const OpeningHoursMessage = styled.span`
	font-size: 1rem;
	line-height: 1.5rem;
	${truncate};

	b {
		color: ${theme.color.text.primary};
		font-weight: 500;
	}
`

export const LoyaltyProgram = styled.div`
	display: flex;
	gap: 4px;
	${NotinoLabelSmall400};
	margin-top: 4px;

	@media (min-width: ${SALON_PAGE_MOBILE_BREAKPOINT}) {
		display: none;
	}
`

export const LoyaltyIconWrapper = styled.div`
	width: 16px;
	height: 16px;

	svg {
		width: 100%;
		height: 100%;
	}
`

export const LoyaltyText = styled.div`
	word-break: break-word;
`
